// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"67877373af82f0b05c93","293":"94a3a3ea516662b1fa6a","518":"5940ca7fc08f7539d2b0","779":"87852cc2a6f5d133d4f9"}[chunkId] + ".js";
};